// 단체 통화 다리 — 1:1 엔진과 단체 엔진이 서로의 '통화 중' 여부와 단체 신호를 주고받는 곳
// 3-2 1호(토대): 표지판을 켜는 쪽·신호 처리 담당은 아직 없음 → 동작 변화 0
let groupBusy = false;
let groupSignalHandler = null;

export function isGroupCallBusy() {
  return groupBusy;
}

export function setGroupCallBusy(value) {
  groupBusy = value === true;
}

export function setGroupSignalHandler(fn) {
  groupSignalHandler = typeof fn === 'function' ? fn : null;
}

export function dispatchGroupSignal(event) {
  if (!groupSignalHandler) return;
  try {
    groupSignalHandler(event);
  } catch (err) {
    console.warn('[단체 통화 다리] 신호 처리 오류', err);
  }
}
